<template>
  <v-sheet class='mt-5'>

    <v-dialog
      v-model="loadingdialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{$t('Submitting Data')}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          {{$t('Message')}}
        </v-card-title>
        <v-card-text> {{$t('Unfortunately at this time, we are unable to bill Medicare, Tricare, or Medicaid plans from states other than Washington.')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click='dialog = false'
          >
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-form
      ref="form_data"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            class='pt-0  pb-0'
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="form_data.firstName"
              :rules="requireRule"
              :label="$t('First name') + '*'"
              required
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            class='pt-0  pb-0'
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="form_data.middleName"
              :label="$t('Middle name')"
              outlined
            ></v-text-field>
          </v-col>

          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="form_data.lastName"
              :rules="requireRule"
              :label="$t('Last name') + '*'"
              outlined
              required
            ></v-text-field>
          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-text-field
              v-model="form_data.email"
              :rules="emailRules"
              :label="$t('Email') + '*'"
              outlined
              required
            ></v-text-field>
          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-text-field
              v-model="form_data.address"
              :rules="requireRule"
              :label="$t('Address') + '*'"
              outlined
              required
            ></v-text-field>

          </v-col>

          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="form_data.zip"
              :rules="requireRule"
              :label="$t('Zip') + '*'"
              outlined
              required
            ></v-text-field>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="4"
          >
            <v-text-field
              v-model="form_data.city"
              :rules="requireRule"
              :label="$t('City') + '*'"
              outlined
              required
            ></v-text-field>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="4"
          >
            <v-select
              item-text="name"
              item-value='abbreviation'
              :items='stateList'
              v-model="form_data.state"
              :rules="requireRule"
              :label="$t('State') + '*'"
              persistent-placeholder
              outlined
              required
            ></v-select>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="form_data.phone"
              :rules="requireRule"
              :label="$t('Phone Number') + '*'"
              outlined
              required
            ></v-text-field>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="form_data.secondPhone"
              :label="$t('Secondary Phone Number') + '*'"
              outlined
            ></v-text-field>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-select
              :items='genderList'
              v-model="form_data.gender"
              :rules="requireRule"
              :label="$t('To which gender identity do you most identify?') + '*'"
              :placeholder="$t('To which gender identity do you most identify?') + '*'"
              persistent-placeholder
              outlined
              required
            ></v-select>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-text-field
              v-mask="'##/##/####'"
              :rules="requireRule"
              v-model="form_data.dob"
              :label="$t('Date of Birth (MM/DD/YYYY)') + '*'"
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-select
              :items='yesNoList'
              v-model="form_data.firstTime"
              :rules="requireRule"
              :label="$t('Is this your first appointment with GSF') + '*'"
              :placeholder="$t('Is this your first appointment with GSF') + '*'"
              persistent-placeholder
              outlined
              required
            ></v-select>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-select
              item-text="name"
              item-value='value'
              :items='reasonList'
              v-model="form_data.reason"
              :rules="requireRule"
              :label="$t('Please select a reason for appointment') + '*'"
              :placeholder="$t('Please select a reason for appointment') + '*'"
              persistent-placeholder
              outlined
              required
            ></v-select>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-text-field
              v-model="form_data.notes"
              :label="$t('Please tell us more about why you would like to see a genetic counselor') + '*'"
              :rules="requireRule"
              outlined
            ></v-text-field>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-select
              item-text="name"
              item-value='value'
              :items='timeZoneList'
              v-model="form_data.timezone"
              :rules="requireRule"
              :label="$t('Please select your time zone') + '*'"
              outlined
              required
            ></v-select>

          </v-col>
          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-select
              item-text="name"
              item-value='value'
              :items='hearGSFList'
              v-model="form_data.aboutGSF"
              :rules="requireRule"
              :label="$t('How did you hear about GSF') + '*'"
              :placeholder="$t('How did you hear about GSF') + '*'"
              persistent-placeholder
              outlined
              required
            ></v-select>

          </v-col>

          <v-col
            class='pt-0 pb-0'
            cols="12"
            sm="12"
          >
            <v-checkbox
              :rules="requireRule"
              required
              v-model="form_data.receivedNoticeofPrivacy"
            > <template v-slot:label>
                <div>

                  <a
                    target="_blank"
                    href="https://geneticsupport.org/tools/gsfdirect/GSF_Privacy_Practices.pdf"
                    @click.stop
                    v-on="on"
                  >
                    {{$t('By checking this box, I acknowledge receipt of GSFs Notice of Privacy Practices')}}
                  </a>
                </div>
              </template>
            </v-checkbox>

          </v-col>

        </v-row>

        <v-btn
          color="primary"
          @click="validate"
        >
          {{$t('Continue')}}
        </v-btn>
        <v-btn
          @click="currentStep = 1"
          text
        >
          {{$t('Back')}}
        </v-btn>

      </v-container>
    </v-form>

  </v-sheet>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import {
  stateList,
  gender,
  yesNo,
  reasonList,
  hearGSF,
  timeZone,
} from "../data/dataSource";

export default {
  data() {
    return {
      form_data: {
        receivedNoticeofPrivacy: false,
        timezone: {
          name: "America/Los_Angeles",
          value: "(GMT-8:00) Pacific Time",
        },
        firstTime: null,
        reason: null,
        timzone: null,
        aboutGSF: null,
        valid: false,
        menu: false,
        zip: null,
        city: null,
        state: null,
        address: null,
        firstName: "",
        middleName: null,
        lastName: null,
        phone: null,
        secondPhone: null,
        gender: null,
        dob: null,
        email: null,
        insuraceType: null,
        planName: null,
        groupName: null,
        insuranceID: null,
        insuranceGroup: null,
      },
      showInsurance: false,
      loadingdialog: false,
      dialog: false,
      valid: false,
      menu: false,
      on: null,
      hearGSFList: hearGSF(),
      timeZoneList: timeZone(),
      reasonList: reasonList(),
      yesNoList: yesNo(),
      stateList: stateList(),
      genderList: gender(),
      requireRule: [(v) => !!v || this.$t("This field is required")],
      emailRules: [
        (v) => !!v || this.$t("E-mail is required"),
        (v) => /.+@.+/.test(v) || this.$t("E-mail must be valid"),
      ],
    };
  },
  computed: {
    ...mapFields([
      "language",
      "uploadId",
      "form",
      "currentStep",
      "selectedStateID",
      "userProfile",
      "inOffice",
    ]),
  },
  mounted() {
    console.log("app mounted");
    this.form = this.form_data;
    // receivedNoticeofPrivacy : true,
    // timezone: {
    //       name: "America/Los_Angeles",
    //       value: "(GMT-8:00) Pacific Time"
    // },
    // notes : "some notes",
    // firstTime : "yes",
    // reason: "1",
    // aboutGSF : "Doctor Referral",
    // zip : "98036",
    // city : "Lynnwood",
    // state : "WA",
    // address : "7307 193rd Pl SW",
    // firstName : "chisan",
    // middleName : "",
    // lastName : "yeung",
    // phone : "2063888251",
    // secondPhone : "",
    // gender : "Male",
    // dob : "2021-01-17",
    // email : "chisan@gmail.com",
  },
  watch: {
    language(val) {
      this.reasonList = reasonList(val);
      this.yesNoList = yesNo(val);
      this.genderList = gender(val);
      this.hearGSFList = hearGSF(val);
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    getBascurrentStep4(file, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        callback(reader.result.replace("data:", "").replace(/^.+,/, ""))
      );
      reader.readAsDataURL(file);
    },

    async validate() {
      this.valid = this.$refs.form_data.validate();

      if (this.valid) {
        this.form.uploadId = this.uploadId;
        this.form.stateId = stateList().find(
          (s) => s.abbreviation === this.form_data.state
        ).stateID;
        this.form_data = this.form;
        this.currentStep = 3;
      }
    },
  },
};
</script>

<style>
.gsfBtn {
  color: #ffffff !important;

  background: #399342;

  border-radius: 5px;

  padding-top: 10px;

  padding-bottom: 10px;

  padding-left: 17px;

  padding-right: 16px;
}

.gsfBtn:hover {
  background: #5ab163;
}
</style>